<!-- <app-applications [pageTitle]="'MEDIATION_LIST.TITLE' | translate" [serviceType]="serviceName.MEDIATION_SERVICES"></app-applications> -->

<div class="bg-white p-5">
  <div class="page-title">
    <h1 class="text-xl font-bold text-dc-navy">
      {{ "MEDIATION_LIST.TITLE" | translate }}
    </h1>

    <app-button
      classesName="btn-edge-cut"
      [label]="'MEDIATION_LIST.BTN_REQUEST' | translate"
      (onBtnClick)="applyForService()"
    >
    </app-button>
  </div>

  <form [formGroup]="filterForm" class="page-filterbar">
    <div class="auto-width-dropdown w-full sm:w-72">
      <!-- 'MEDIATION_LIST.FILTER.STATUS' | translate -->
      <app-option-field
        class="min-w-72"
        [control]="filterForm.get('status')"
        [label]="''"
        [options]="caseStatus"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        (onSelectionChange)="applyFilter($event)"
      />
    </div>

    <div class="ms-auto w-full sm:w-72 pt-1.5">
      <div
        class="flex items-center border border-dc-navy text-dc-navy font-light overflow-hidden"
      >
        <input
          type="text"
          [placeholder]="'MEDIATION_LIST.SEARCH_BY_CASE_NO' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          formControlName="search"
          (keydown.enter)="search()"
          (keyup)="removeSearch($event)"
        />
        <button type="button" class="px-4 text-dc-navy" (click)="search()">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form>

  <app-table
    [tableHeadings]="[
      'MEDIATION_LIST.COL.CASE_NUMBER' | translate,
      'MEDIATION_LIST.COL.RESPONDENT_COMPANY' | translate,
      'MEDIATION_LIST.COL.COMPLAINANT_COMPANY' | translate,
      'MEDIATION_LIST.COL.DISPUTE_AMOUNT' | translate,
      'MEDIATION_LIST.COL.STATUS' | translate
    ]"
    [dataKeys]="[
      'Serial Number',
      lang == 'en' ? 'DC SR Respondant Name ENU' : 'DC SR Respondant Name ARA',
      lang == 'en'
        ? 'DC SR Complainant ENU Name'
        : 'DC SR Complainant ARA Name',
      'DC SR Dispute Amount',
      'DC Status'
    ]"
    [listData]="caseList"
    [showActions]="true"
    [showPagination]="true"
    [showActionView]="true"
    [loader]="loading"
    [pageSize]="pageSize"
    [totalRecords]="totalRecords"
    (onPageChange)="pageChange($event)"
    (onView)="view($event)"
  >
  </app-table>
</div>
